mainApp.component('slaSettingsReoptimize', {
    templateUrl: '/public/components/configuration/slaSettings/sla-settings-reoptimize-configuration.component.html',
    bindings: {
        model: '=',
        siteId: '<?',
        showOverrideCheckbox: '<?',
    },
    controller: slaSettingsReoptimizeConfigurationController
});


function slaSettingsReoptimizeConfigurationController(SlaSettingService) {
    const ctrl = this;
    const ONE_MINUTE_IN_SECONDS = 60

    ctrl.$onChanges = (changes) => {
        if(changes.siteId && ctrl.model) {
            setReoptimizeTimeInMin();
        }
    }

    let setReoptimizeTimeInMin = () => {
        if (ctrl.model.reoptimizeTime){
            ctrl.reoptimizeTimeInMin = ctrl.model.reoptimizeTime / ONE_MINUTE_IN_SECONDS;
        } else {
            ctrl.reoptimizeTimeInMin = SlaSettingService.DEFAULT_REOPTIMIZE_TIME_IN_MIN;
        }
    }

    ctrl.disableInput = () => {
        return ctrl.siteId && !ctrl.model?.overrideAccountReoptimizeTime
    }

    ctrl.updateReoptimizeTime = () => {
        ctrl.model.reoptimizeTime = ctrl.reoptimizeTimeInMin * ONE_MINUTE_IN_SECONDS;
    }

    ctrl.updateDisableReoptimization = () => {
        ctrl.model.disableReoptimization = !ctrl.model.overrideAccountReoptimizeTime
    }
};
